<template>
    <div class="hos-form">
        <div class="sub_title fb"><img src="../../assets/icon/Rectangle2.png" class="mr10 imgb">预约信息</div>
        <div class="mt10 flex jcb pt10 pb10 pl20 pr20 fs14">
            <div class="flex">
                <img class="docAva" :src="docAva" alt="">
                <div class="flex column ml20 jcc">
                    <span class="mb5">{{info.docName}}</span>
                    <span class="mb5">{{info.hosName}}</span>
                    <span>{{info.deptName}}</span>
                </div>
            </div>
            <div class="flex aic jcc">
                <div style="text-align:center">
                    <p class="mb5">{{info.schdate|schdateFilter}}</p>
                    <p class="mb5">{{info.week}}</p>
                    <p>{{info.ampm|ampmFilter}}</p>
                </div>
            </div>
            <div class="flex aic jcc">
                <div style="text-align:center">
                    <p class="mb5">挂号费:</p>
                    <p class="mb5 red">￥{{info.regfee}}元</p>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
  import {orderTime} from "../../lib/cache/OrderTime";
  import {schdateFilter,ampmFilter} from "../../lib/filters"

  export default {
    name: "departmentList",
    props: {
      info: {
        type: Object,
        default: ()=>{
            return {}
        }
      },
    },
    data() {
      return {
        id: '1',
          docAva:require('../../assets/docAva.png')
      }
    },
    watch: {
      id(newV) {
        this.$emit('input', newV);
      }
    },
    filters:{schdateFilter,ampmFilter},
    methods:{
      saveDept(a){
        const ot = orderTime.get()
        ot.deptId = a.ksid
        ot.deptName = a.ksmc
        orderTime.set(ot)
        this.$router.push('/main/registration/schedule')
      },
    }
  }
</script>

<style scoped lang="scss">
    @import "../../styles/var";
    .hos-form{
        padding: 10px 20px;
        color: #666666;
        span+span{
            margin-right: 10px;
            cursor: pointer;
        }
    }
    .sub_title{
        padding: 5px 0px;
        color: #1E1E1E;
    }
    .bg_pra{
        background-color: $bgPrimaryColor;
    }
    .red{
        color: red;
    }
    .imgb{
        vertical-align: bottom;
    }
    .center{
        text-align: center;
        span{
            display: block;
        }
    }
    .fb{
        font-weight: bold;
    }
    .docAva{
        width: 84px;
        height: 84px;
    }
</style>
